import { DEAL_TYPES, PROMO_CODE_TYPES } from '../../../../../services/exports/Constants';

export default {
  title: 'Offres spéciales',
  view_more: 'Voir plus',
  badges: {
    PROMO: 'Promo',
    DEAL: 'Bon plan',
    'FREE ITEM': 'Article gratuit',
    REWARDS: 'Récompenses',
  },
  deals: {
    [DEAL_TYPES.GOOGLE_REVIEW_PROGRAM]: {
      title: '+{{reward}} points supplémentaires',
      description: 'Notez-nous sur Google',
    },
    [DEAL_TYPES.SMART_PRICING_RULE]: {
      title: 'Offre spéciale',
      description: 'Déjà appliqué automatiquement',
    },
    buttons: {
      add: 'Ajouter',
      remove: 'Retirer',
      show_details: 'Voir les détails',
    },
    mobile_app_signup_bonus: {
      title: "{{amount}} bonus d'inscription via l'appli",
      desc: 'Obtenez {{amount}} de cashback en vous connectant sur notre appli.',
    },
    welcome_bonus: {
      title: '{{amount}} bonus de bienvenue',
      desc: 'Obtenez {{amount}} de cashback en vous inscrivant.',
    },
  },
  discounts: {
    title: '{{discount}} de réduction',
    usage_threshold: '(Min : {{amount}})',
    description: {
      [PROMO_CODE_TYPES.ONE_TIME_PROMO_CODE]:
        '{{discount}} de réduction sur votre prochaine commande - code : {{code}}',
      [PROMO_CODE_TYPES.MULTI_PROMO_CODE]:
        '{{discount}} de réduction sur vos {{count}} prochaines commandes - code : {{code}}',
    },
  },
  feedback: {
    login:
      "<highlight>Connectez-vous</highlight> pour utiliser cette promo afin de vérifier que vous ne l'avez pas encore utilisée. Connectez-vous et réessayez.",
  },
};
